module.exports = __webpack_public_path__ + "static/alltoowordy-b0815ef87dcc78899b2117cf2ba54367.jpeg";